import {
  SingleDesignation,
  SingleDesignationDesignationAttribute,
} from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { ConstraintStatus, LayerState } from "./store";
import { DesignationFeatureProps } from "react-migration/domains/constraints/components/ConstraintLayer/DesignationLayer";

type AttributeKey = string;
type AttributeValue = string;
type HiddenDesignationAttributesMap = Record<AttributeKey, AttributeValue[]>;

function isDesignationAttributeHidden(
  designationAttribute: SingleDesignationDesignationAttribute,
  hiddenDesignationAttributesMap?: HiddenDesignationAttributesMap
) {
  const hiddenValues = hiddenDesignationAttributesMap?.[designationAttribute.key];
  return !!hiddenValues?.includes(designationAttribute.value!);
}

export const apiDesignationIsVisible = (designation: SingleDesignation, layerState: LayerState | undefined) => {
  const { visibleCategories, hiddenStatuses, hiddenDesignationAttributes } = layerState || {};

  if (!visibleCategories?.includes(designation.sub_category_id!)) return false;

  return (
    !hiddenStatuses?.includes(designation.source.status! as ConstraintStatus) &&
    (!designation.designation_attributes ||
      !designation.designation_attributes?.some((a) => isDesignationAttributeHidden(a, hiddenDesignationAttributes)))
  );
};

export const tileDesignationIsVisible = (designation: DesignationFeatureProps, layerState: LayerState | undefined) => {
  const { visibleCategories, hiddenStatuses, hiddenDesignationAttributes } = layerState || {};

  if (!visibleCategories?.includes(designation.sub_category_id)) return false;

  return (
    !hiddenStatuses?.includes(designation.status! as ConstraintStatus) &&
    (!designation.designation_attributes ||
      !designation.designation_attributes.some((designationAttribute) =>
        isDesignationAttributeHidden(designationAttribute, hiddenDesignationAttributes)
      ))
  );
};
